export const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const getCurrentWeek = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  const diff = now - start;
  const oneWeek = 1000 * 60 * 60 * 24 * 7;
  return Math.ceil(diff / oneWeek);
};

// Optional: You might want to add this helper function
export const getWeekAndYear = () => {
  return {
    week: getCurrentWeek(),
    year: getCurrentYear(),
  };
};
